export { default as useToggleLifestyleFavorite } from './useToggleLifestyleFavorite';
